/*jshint esversion: 6 */
/*! webmd.offsite */
import { MessageBox } from 'webmd-elements'

// Offsite links
export default {
    methods: {
        getOffsiteSettings(options) {
            const defaults = {
              title: `Thank you for visiting WebMD`,
              message: `You are about to visit a website outside of WebMD. Please familiarize yourself with this other website\'s Privacy Policy as it differs from ours.`,
              size: 'large',
              scope: this.$el,
              newWindow: null,
            };
            const excludeDomains = ['webmd.com', 'rxlist.com', 'emedicinehealth.com', 'medicinenet.com', 'medscape.com', 'surveywriter.net'];
            defaults.excludeDomains = excludeDomains;
            return Object.assign({}, defaults, options);
          },
        handleOffsiteLinks(options) {
            const settings = this.getOffsiteSettings(options);
            const elements = settings.scope.querySelectorAll('a');

            elements.forEach((el) => {
                const dom = el.hostname.split('.');
                const sDomain = `${dom[dom.length - 2]}.${dom[dom.length - 1]}`;

                if (el.href && !settings.excludeDomains.includes(sDomain)) {
                    let target;
                    if (typeof settings.newWindow === 'boolean') {
                        target = settings.newWindow ? '' : '_new';
                    } else {
                        target = '_new';
                    }

                    el.setAttribute('data-metrics-type', 'ad-hoc');
                    el.addEventListener('click', (event) => {
                        event.preventDefault();
                        setTimeout(() => {
                            MessageBox.confirm(settings.message, settings.title, {
                                size: settings.size,
                            })
                                .then(() => {
                                    window.open(el.href, target);
                                })
                                .catch(() => {
                                    // do nothing if action is cancel
                                });
                        }, 0);
                    });
                }
            });
        },
        handleOffsiteRedirect (options) {
            const settings = this.getOffsiteSettings(options);
            if (settings && settings.url) {
                const url = new URL(settings.url);
                const dom = url.hostname.split('.');
                const sDomain = `${dom[dom.length - 2]}.${dom[dom.length - 1]}`;
                if (settings.excludeDomains.includes(sDomain)) {
                    // If sDomain is in excludeDomains, open the URL directly
                    const tag = settings.newWindow ? settings.newWindow : '_new';
                    window.open(settings.url, tag);
                } else {
                    MessageBox.confirm(settings.message, settings.title, {
                        size: settings.size,
                    })
                        .then(() => {
                            const tag = settings.newWindow ? settings.newWindow : '_parent';
                            window.open(settings.url, tag);
                        })
                        .catch(() => {
                            // do nothing if action is cancel
                        });
                }
            }
        }
        
    }
}
